// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import 'vuetify/styles/main.sass';
import 'vuetify/styles'
// Vuetify
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

export default createVuetify({
  theme: {
    themes: {
      light: {
        colors: {
          'brand-green': '#00C16A',
          background: '#ffffff',
          surface: '#ffffff',
        },
      },
    },
  },
  components,
  directives
})
